module.exports = __webpack_public_path__ + "img/shopify-limitations-for-e-commerce-img-2.2df473af.jpeg";